import { Container, Graphics } from 'pixi.js';
import gsap from 'gsap';
import { COLORS, SCREEN, TIMING } from '../config/tokens';
import { killTweensDeep, type Layout } from '../render/stage';
import { reducedMotion } from '../render/fx';
import { roundedPanel } from './components';

export interface Modal {
  panel: Container;
  close(): void;
}

/**
 * Uniform scrim + centred cream panel (§14 layers 9 and 10). The scrim
 * swallows taps so nothing behind the modal reacts.
 */
export function openModal(parent: Container, l: Layout | undefined, w: number, h: number): Modal {
  const root = new Container();
  const scrim = new Graphics()
    .rect(l?.left ?? 0, 0, (l?.right ?? SCREEN.width) - (l?.left ?? 0), l?.bottom ?? SCREEN.height)
    .fill({ color: COLORS.cocoa, alpha: 0.45 });
  scrim.eventMode = 'static';
  const panel = new Container();
  panel.addChild(roundedPanel(w, h));
  panel.pivot.set(w / 2, h / 2);
  panel.position.set(SCREEN.width / 2, l ? (l.safeTop + l.safeBottom) / 2 : SCREEN.height / 2);
  root.addChild(scrim, panel);
  parent.addChild(root);
  scrim.alpha = 0;
  gsap.to(scrim, { alpha: 1, duration: 0.2 });
  panel.alpha = 0;
  panel.scale.set(0.92);
  gsap.to(panel, { alpha: 1, duration: TIMING.panelIn / 1000 });
  gsap.to(panel.scale, { x: 1, y: 1, duration: TIMING.panelIn / 1000, ease: reducedMotion ? 'none' : 'back.out(1.6)' });
  let closed = false;
  return {
    panel,
    close() {
      if (closed) return;
      closed = true;
      root.eventMode = 'none';
      gsap.to(root, {
        alpha: 0,
        duration: 0.15,
        onComplete: () => {
          killTweensDeep(root);
          root.destroy({ children: true });
        },
      });
    },
  };
}
